export default {
  "header.hit": "ヒット数",
  "header.count": "件",
  "form.keyword": "検索キーワード：",
  "form.category": "検索カテゴリー：",
  "form.category.all": "全ページ",
  "form.category.select": "カテゴリーを選んでください",
  "form.submit": "検索する",
  "list.title": "一覧",
  "list.noResult": "と一致する結果は見つかりませんでした。",
  "tagSearch.list.title": "一覧",
  "tagSearch.eventStart.label": "開催日",
} as const;
